var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-menu-container"},[_c('span',{staticStyle:{"font-size":"14px","font-weight":"500","color":"#0051cf","padding-left":"2px"}},[_vm._v(_vm._s(_vm.moduleMenuTitle))]),_c('AppSubmenu',{key:_vm.menuKey,staticClass:"layout-menu",attrs:{"items":_vm.model,"root":true},on:{"menuitem-click":_vm.onMenuItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }